<template>
  <div v-if="form">
    <div class="header">MSDS 리스트 관리 (2025년 05월)</div>
    <div class="content">
      <div class="content-title">□ 사업장정보</div>
      <div class="content-table">
        <table>
          <tbody>
            <tr>
              <th>사업장명</th>
              <td>{{ form.stdInfo.field_name }}</td>
              <th>부서명</th>
              <td>{{ form.stdInfo.부서명_과 }}</td>
            </tr>
            <tr>
              <th>팀명</th>
              <td>{{ form.stdInfo.com_name }}</td>
              <th>담당주무관</th>
              <td>{{ form.stdInfo.writer_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MSDS-->
    <div class="content">
      <div class="content-title">□ MSDS</div>
      <div class="content-table">
        <table>
          <colgroup>
            <col width="40" />
            <col width="70" />
            <col width="70" />
            <col width="130" />
            <col width="60" />
            <col width="120" />
            <col width="247" />
            <col width="70" />
            <col width="48" v-for="_ in 13" :key="`col_${_}`" />
            <col width="80" />
            <col width="150" />
          </colgroup>
          <thead>
            <tr>
              <th rowspan="2">No.</th>
              <th rowspan="2">소속</th>
              <th rowspan="2">작업공정<br />(담당명)</th>
              <th rowspan="2">물질명<br />(제품명)</th>
              <th rowspan="2">월 사용량</th>
              <th colspan="3">구성성분 및 함유량</th>
              <th rowspan="2">
                측정<br />
                대상
              </th>
              <th rowspan="2">측정<br />주기</th>
              <th rowspan="2">
                특검<br />
                대상
              </th>
              <th rowspan="2">
                특검<br />
                주기
              </th>
              <th rowspan="2">
                특별<br />
                관리<br />
                물질
              </th>
              <th rowspan="2">
                관리<br />
                대상<br />
                물질
              </th>
              <th colspan="8">관리상태</th>
              <th rowspan="2">비고</th>
            </tr>
            <tr>
              <th>CAS번호</th>
              <th>구성성분</th>
              <th>
                함유량<br />
                (%)
              </th>
              <th>
                MSDS<br />
                게시
              </th>
              <th>
                MSDS<br />
                관리<br />
                요령<br />
                게시
              </th>
              <th>
                경고<br />
                표지 <br />
                부착
              </th>
              <th>MSDS<br />교육</th>
              <th>
                특별<br />
                교육
              </th>
              <th>
                적정<br />
                보호구<br />
                지급
              </th>
              <th>
                특수<br />
                건강<br />
                진단<br />
                실시
              </th>
              <th>변동사항</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(_msds, _msds_i) in form.msds" :key="`msds_${_msds_i}`">
              <td>{{ _msds_i + 1 }}</td>
              <td>{{ _msds.소속 }}</td>
              <td>{{ _msds.작업공정 }}</td>
              <td>{{ _msds.물질명 }}</td>
              <td>{{ _msds.월사용량 || "-" }}/L</td>
              <td>{{ _msds.CAS번호 }}</td>
              <td>{{ _msds.구성성분 }}</td>
              <td>{{ _msds.함유량 || "-" }}%</td>
              <td>
                <PrintCheckbox :value="_msds.측정대상 ? true : false" class="justify-center" />
              </td>
              <td>{{ _msds.측정주기 || "-" }}개월</td>
              <td>
                <PrintCheckbox :value="_msds.특검대상 ? true : false" class="justify-center" />
              </td>
              <td>{{ _msds.특검주기 || "-" }}개월</td>
              <td><PrintCheckbox :value="_msds.특별관리물질 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.관리대상물질 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.MSDS게시 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.MSDS관리요령게시 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.경고표지부착 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.특별교육 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.MSDS교육 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.적정보호구지급 ? true : false" class="justify-center" /></td>
              <td><PrintCheckbox :value="_msds.특수건강진단실시 ? true : false" class="justify-center" /></td>
              <td>{{ _msds.변동사항 }}</td>
              <td>{{ _msds.비고 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--    사전조사 및 작업계획서 내용-->
    <div class="content">
      <div class="content-table">
        <template v-for="(table, index) of form.inspectionList" v-if="table.check">
          <div :class="index > 1 ? 'print-break-page' : 'print-break'">
            <div class="content-title">□ {{ table.label }}</div>
            <table>
              <tbody>
                <template v-for="group of table.list">
                  <tr>
                    <td class="th-background">{{ group.headerTitle }}</td>
                    <td class="th-background" style="width: 70px">작성</td>
                    <td class="th-background" style="width: 70px">미작성</td>
                    <td class="th-background" style="width: 70px">N/A</td>
                  </tr>
                  <tr v-for="(row, index) of group.list" :key="index">
                    <td class="text-left">
                      <span v-html="row.label"></span><span v-for="(sign, signIndex) of row.sign" :key="signIndex" style="padding-left: 18px">{{ sign.name }} : {{ sign.value }}</span>
                    </td>
                    <td>
                      <img v-if="row.is_checked === 'Yes'" src="@/assets/images/print/print_check_checked.svg" alt="checked" />
                      <img v-else src="@/assets/images/print/print_check_unchecked.svg" alt="unchecked" />
                    </td>
                    <td>
                      <img v-if="row.is_checked === 'No'" src="@/assets/images/print/print_check_checked.svg" alt="checked" />
                      <img v-else src="@/assets/images/print/print_check_unchecked.svg" alt="unchecked" />
                    </td>
                    <td>
                      <img v-if="row.is_checked === 'N/A'" src="@/assets/images/print/print_check_checked.svg" alt="checked" />
                      <img v-else src="@/assets/images/print/print_check_unchecked.svg" alt="unchecked" />
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
export default {
  components: { PrintCheckbox },
  props: {
    board: Object,
    form: Object,
  },
  computed: {},
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      console.log(this.form.msds);
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content {
  margin-top: 20px;

  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 16px;
  }
  .content-table {
    .print-break {
      break-inside: avoid;
    }
    .print-break-page {
      page-break-before: always;
    }

    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 40px;

      th,
      td {
        min-height: 55px;
        height: 55px;

        font-size: 12px;
        font-weight: 400;
        text-align: center;

        border: 1px solid #757575;
      }

      th {
        background-color: #ececec;
        font-weight: 700;
        padding: 0;
      }

      td {
        word-wrap: break-word;
        word-break: break-word;
        white-space: normal;
      }
    }
  }
}
@media print {
  tr {
    page-break-inside: avoid; /* 행 단위로 분리되지 않게 */
  }

  table {
    page-break-inside: auto;
    page-break-after: auto;
    width: 100%;
    table-layout: fixed;
  }
}
</style>
